// extracted by mini-css-extract-plugin
module.exports = {"input":"Input__input__Cojzg","label":"Input__label__PmMd0"};